<!--
 * @Author: Tahiti
 * @Date: 2025-10-21 15:03:16
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-30 16:31:12
 * @Description: 
 * @FilePath: /weryai-web/components/Tool/ImageUploadMult.vue
-->
<template>
    <div class="mt-4">
        <label class="flex items-center text-white text-sm font-semibold mb-3">
            <span> {{ label || t('tools.imageLabel') }}</span>
            <span class="text-sub-title text-xs ml-1">
                ({{ edit_image_list?.length }}/{{ maxLimitCount }})
            </span>
            <ClientOnly v-if="props?.show_tips">
                <el-popover width="180" :content="tip_content || t('seo.imageToImage.page.upload_image')
                    ">
                    <template #reference>
                        <img class="w-3 h-3 ml-2 cursor-help"
                            src="https://static.weryai.com/growth/image/4c8570087b6d87697059b93e7295b008.webp"
                            alt="info" />
                    </template>
                </el-popover>
            </ClientOnly>
        </label>
        <div
            class="w-full bg-tool-default-black border border-white/[.06] rounded-[10px] p-[10px] min-h-[120px] max-h-[130px]">
            <div v-if="!edit_image_list?.length" @click="triggerFileUpload" @dragover.prevent
                @drop.prevent="handleFileDrop"
                class="flex h-full w-full group text-sub-title hover:text-white flex-col items-center justify-center gap-[10px] rounded-[10px] text-center cursor-pointer transition-all">

                <div
                    class="flex items-center justify-center flex-col w-[100px] h-[100px] border border-dashed border-white/20 rounded-lg p-2 gap-[10px]">
                    <ui-upload-icon :hoverable="true" />

                    <p class="text-sub-title text-xs group-hover:text-white">
                        {{ t('tools.imageUploadSingle') }}
                    </p>
                </div>
                <input ref="fileInput" type="file" multiple accept="image/*" @change="handleFileSelect"
                    class="hidden" />
            </div>

            <!-- Uploaded Images Grid -->
            <div v-if="edit_image_list?.length"
                class="flex gap-2 overflow-x-auto scrollbar-custom rounded-[10px] items-center justify-start">
                <div v-for="(image, index_) in edit_image_list" :key="typeof image === 'string' ? image : `loading-${index_}`
                    "
                    class="w-[100px] h-[100px] flex-shrink-0 group aspect-square rounded-lg overflow-hidden flex items-center justify-center relative cursor-pointer">
                    <div v-if="!image?.loading">
                        <img :src="image" :alt="index_?.toString()" class="object-cover w-full h-full"
                            @load="markImageLoaded(image)" @error="handleImgError(image)" />

                        <!-- 图片还在加载时的遮罩 loading（只对 URL 图片生效） -->
                        <div v-if="
                            typeof image === 'string' &&
                            !isImageLoaded(image)
                        " class="absolute inset-0 z-[3] flex items-center justify-center bg-black/70">
                            <l-dot-spinner v-if="isClient" size="40" speed="0.9"
                                color="var(--el-menu-active-color)"></l-dot-spinner>
                        </div>

                        <button
                            class="inline-flex rounded-full items-center justify-center whitespace-nowrap text-base font-medium ring-offset-background duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:text-accent-foreground absolute z-[2] top-1 right-1 h-[22px] w-[22px] bg-[#2E2E2E] text-white group-hover:opacity-100 transition-opacity"
                            @click.stop="deleteUploadedImage(index_)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13"
                                fill="none" class="w-3 h-3">
                                <path d="M9 3.68164L3 9.68164" stroke="white" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M3 3.68164L9 9.68164" stroke="white" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </button>
                        <div
                            class="absolute !hidden w-6 h-6 bottom-1 right-1 bg-[#1D1D1D] text-white text-base px-1 rounded-full">
                            {{ index_ + 1 }}
                        </div>
                        <div
                            class="mask opacity-0 group-hover:opacity-100 absolute z-1 top-0 left-0 w-full h-full bg-black/30 rounded-lg transition-opacity duration-200">
                        </div>
                    </div>
                    <div v-else class="w-20 h-20 flex items-center justify-center">
                        <l-dot-spinner v-if="isClient" size="40" speed="0.9"
                            color="var(--el-menu-active-color)"></l-dot-spinner>
                    </div>
                </div>
                <!-- Add More Button -->
                <div v-if="edit_image_list?.length < maxLimitCount"
                    class="w-[107px] h-[107px] bg-black/30 group cursor-pointer border border-dashed border-white/20 text-text-adad text-base aspect-square rounded-[10px] flex flex-col items-center justify-center transition-colors add-image-btn hover:border-white/30"
                    @click="triggerFileUpload" @dragover.prevent @drop.prevent="handleFileDrop">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <g clip-path="url(#clip0_8933_29167)">
                            <path
                                d="M21 15V18H24V20H21V23H19V20H16V18H19V15H21ZM21.0082 3C21.556 3 22 3.44495 22 3.9934V13H20V5H4V18.999L14 9L17 12V14.829L14 11.8284L6.827 19H14V21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082ZM8 7C9.10457 7 10 7.89543 10 9C10 10.1046 9.10457 11 8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7Z"
                                fill="#ADADAD" />
                        </g>
                        <defs>
                            <clipPath id="clip0_8933_29167">
                                <rect width="24" height="24" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                    <span class="text-sub-title text-sm mt-[10px]">
                        {{ t('tools.addImage') }}
                    </span>
                    <input ref="fileInput" type="file" multiple accept="image/*" @change="handleFileSelect"
                        class="hidden" />
                </div>
            </div>
        </div>
        <div class="text-sub-title text-xs flex gap-1 ml-1 items-center mt-1">
            <el-icon class="!text-sm">
                <Warning />
            </el-icon>
            {{ t('upload.errors.fileTooLarge', { maxSize: 10 }) }}
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed, ref, onMounted, watch } from 'vue'
import { Warning } from '@element-plus/icons-vue'
import { useI18n } from '@/composables/useI18n'
import { debounce, noticeMessagePopup, getMaxImageSize } from '@/utils/common'
import { emitOpenImagePreview, showLoginModal } from '~/utils/emitter'
import axios from 'axios'
import { useUserStore } from '~/stores/user'

const props = withDefaults(
    defineProps<{
        show_tips?: boolean
        tip_content?: string
        label?: string
    }>(),
    {
        show_tips: false,
        tip_content: '',
        label: '',
    }
)

const { t, locale } = useI18n()

const uploadCount = ref(0)

const model = defineModel('model', {
    type: String,
    default: '',
})

const maxLimitCount = defineModel('upload_image_limit', {
    type: Number,
    default: 10,
})

const edit_image_list = defineModel('image_list', {
    type: Array<any>,
    default: () => [],
})

const userStore = useUserStore()

const fileInput = ref<HTMLInputElement | null>(null)

/**
 * 图片“加载中”状态（仅针对已经拿到 URL 的图片）。
 * - key 使用图片 URL（字符串）
 * - value: true 表示浏览器已触发 img.onload（可以展示图片本体）
 */
const imageLoadedMap = ref<Record<string, boolean>>({})

const isImageLoaded = (image: any) => {
    if (typeof image !== 'string') return false
    return !!imageLoadedMap.value[image]
}

const markImageLoaded = (image: any) => {
    if (typeof image !== 'string') return
    imageLoadedMap.value[image] = true
}

const handleImgError = (image: any) => {
    // 出错也把 loading 关掉（避免遮罩一直转）
    markImageLoaded(image)
    onImageError()
}

// 当图片列表变化时：为新 URL 初始化为“未加载”；并清理已不存在的 URL，避免内存增长
watch(
    () => edit_image_list.value,
    list => {
        const urlSet = new Set<string>()
            ; (list || []).forEach(item => {
                if (typeof item === 'string') urlSet.add(item)
            })
        // init new
        urlSet.forEach(url => {
            if (imageLoadedMap.value[url] === undefined) {
                imageLoadedMap.value[url] = false
            }
        })
        // cleanup removed
        Object.keys(imageLoadedMap.value).forEach(url => {
            if (!urlSet.has(url)) delete imageLoadedMap.value[url]
        })
    },
    { deep: true, immediate: true }
)

const checkUploadMax = () => {
    if (uploadCount.value) {
        noticeMessagePopup(
            t('tools.pleaseWaitingUpload'),
            t('common.tip'),
            'warning',
            3000,
            ''
        )
        return false
    }

    if (edit_image_list.value.length > maxLimitCount.value - 1) {
        noticeMessagePopup(
            t('tools.maxUploadCount', { count: maxLimitCount.value }),
            t('common.tip'),
            'warning',
            3000,
            ''
        )

        return false
    }
    return true
}

const isLoggedIn = computed(() => userStore.isLoggedIn)

const triggerFileUpload = () => {
    if (!isLoggedIn.value) {
        showLoginModal()
        return
    }
    if (!checkUploadMax()) return

    fileInput.value?.click()
}

// drag upload
const handleFileDrop = (event: DragEvent) => {
    if (!isLoggedIn.value) {
        showLoginModal()
        return
    }
    if (!checkUploadMax()) return

    const files = event.dataTransfer?.files
    if (files) {
        const fileArray = Array.from(files)
        handleAutoBatchUpload(fileArray)
    }
}

const uploadFileList = ref<File[]>([])

// @ts-ignore
const config = useRuntimeConfig()
let token = ''
let language = ''

// upload image
const handleAutoBatchUpload = debounce(async (fileList: File[]) => {
    if (!fileList?.length) return
    // @ts-ignore

    // 校验文件大小（限制为10MB），过滤出符合要求的文件
    const validFiles: File[] = []
    const invalidFiles: { name: string; size: number }[] = []

    for (const file of fileList) {
        if (getMaxImageSize(file, 10)) {
            validFiles.push(file)
        } else {
            invalidFiles.push({ name: file.name, size: file.size })
        }
    }

    // 如果有文件超过限制，显示错误提示
    if (invalidFiles.length > 0) {
        const invalidFileNames = invalidFiles.map(f => f.name).join(', ')
        const errorMessage =
            invalidFiles.length === 1
                ? `${t('upload.errors.fileTooLarge', { maxSize: 10 })}: ${invalidFileNames}`
                : `${t('upload.errors.fileTooLarge', { maxSize: 10 })} (${invalidFiles.length} files): ${invalidFileNames}`

        noticeMessagePopup(errorMessage, t('common.tip'), 'error', 10000, '')
    }

    // 如果所有文件都超过限制，阻止上传
    if (validFiles.length === 0) {
        return
    }

    // 使用过滤后的有效文件列表
    const fileListToUpload = validFiles

    if (
        fileListToUpload.length + edit_image_list.value.length >
        maxLimitCount.value
    ) {
        noticeMessagePopup(
            t('tools.maxUploadCount', { count: maxLimitCount.value }),
            t('common.tip'),
            'warning',
            3000,
            ''
        )

        return
    }

    uploadFileList.value = fileListToUpload
    uploadCount.value = fileListToUpload.length

    let item_: any = {
        loading: true,
    }
    for (let i = 0; i < uploadCount.value; i++) {
        edit_image_list.value.push(item_)
    }

    // set skeleton screen number
    const formData = new FormData()
    uploadFileList.value.forEach((fileObj: File) => {
        formData.append('files', fileObj)
    })
    try {
        // @ts-ignore
        if (import.meta.client) {
            token = localStorage.getItem('token') || ''
            // 请求语言跟随当前 URL 的 locale，而不是偏好/旧的 localStorage('language')
            language = locale.value || 'en'
        }
        const url = new URL(
            config.public.apiBase + '/api/v1/auth/s3/upload_images'
        )
        url.searchParams.append('app_key', config.public.appKey)

        const res = await axios.post(url.toString(), formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: token,
                'Accept-Language': language,
            },
        })

        const { data, status } = res.data
        if (status === 200) {
            // remove loading placeholder
            edit_image_list.value.splice(-uploadCount.value, uploadCount.value)
            // add actually uploaded image URL
            edit_image_list.value.push(...data?.object_url_list)

            uploadCount.value = 0
        } else if ([1005, 4001, 4002].includes(status)) {
            showLoginModal()
        } else {
            edit_image_list.value.splice(-uploadCount.value, uploadCount.value)
            uploadCount.value = 0
        }
    } catch (err) {
        // when upload failed, remove loading placeholder, restore original state
        edit_image_list.value.splice(-uploadCount.value, uploadCount.value)
        uploadCount.value = 0
        console.error('upload failed:', err)
    } finally {
    }
}, 500)

// select file upload
const handleFileSelect = (event: Event) => {
    const target = event.target as HTMLInputElement
    const files = target.files as FileList

    if (edit_image_list.value.length > maxLimitCount.value - 1) {
        noticeMessagePopup(
            t('tools.maxUploadCount', { count: maxLimitCount.value }),
            t('common.tip'),
            'warning',
            3000,
            ''
        )
        // 重置 input 值，允许再次选择相同文件
        target.value = ''
        return false
    }
    // convert FileList to File[] array
    const fileArray = Array.from(files)
    // 直接调用 handleAutoBatchUpload，文件大小校验在 handleAutoBatchUpload 中统一处理
    handleAutoBatchUpload(fileArray)
    // 重置 input 值，允许再次选择相同文件
    target.value = ''
}

const onImageError = () => {
    noticeMessagePopup(
        t('tools.imageLoadFailed'),
        t('common.tip'),
        'warning',
        3000,
        ''
    )
    edit_image_list.value = []
}

// delete uploaded image
const deleteUploadedImage = (index: number) => {
    edit_image_list.value.splice(index, 1)
}

const isClient = ref(false)

// 只在客户端注册 ldrs
onMounted(async () => {
    if (typeof window !== 'undefined') {
        try {
            const { dotSpinner } = await import('ldrs')
            dotSpinner.register()
            // 确保注册完成后再设置 isClient，避免组件在注册前渲染
            isClient.value = true
        } catch (error) {
            console.error('Failed to load ldrs:', error)
            // 即使加载失败也设置为 true，避免无限等待
            isClient.value = true
        }
    }
})
</script>
<style scoped lang="less"></style>
